// 📄 hooks/useOrganizations.ts
//
// Sub-fase G1: wrapper delgado sobre AuthContext, que desde esta sub-fase
// es la ÚNICA fuente de fetch de "organizaciones del usuario" (antes este
// hook hacía su propio fetch independiente — se consolidó en AuthContext
// para evitar dos fetches paralelos escribiendo el mismo localStorage key
// y arriesgando desincronización). Mismo shape público que antes
// (`organizations`, `orgActiva`, `orgActivaId`, `setOrgActiva`, `loading`,
// `reload`) para que OrganizationsSection.tsx y ProjectContext.tsx (ya
// existentes) sigan funcionando sin ningún cambio.

import { useAuth } from '../context/AuthContext.tsx';

export function useOrganizations() {
  const { organizations, orgActual, orgsLoading, setOrgActual, reloadOrganizations } = useAuth();

  return {
    organizations,
    orgActiva: orgActual,
    orgActivaId: orgActual?.id ?? null,
    setOrgActiva: setOrgActual,
    loading: orgsLoading,
    reload: reloadOrganizations
  };
}
